/**
 * Company user profile role.
 */
export enum CompanyUserProfileRole {
	Admin = "company-admin",
	User = "user",
	Customer = "customer",
	Guest = "guest"
}
